import { colors } from '@constants/colors';
import { ScreenSizes } from '@interfaces';
import { useTheme } from '@mui/material';

export const useStyle = () => {
  const { breakpoints } = useTheme();

  return {
    root: {
      cursor: 'pointer',
      ml: '0 !important',
      backgroundColor: 'transparent',
      marginX: 1,
      width: 44,
      height: 44,
      borderRadius: '100%',

      '&:hover': {
        backgroundColor: colors.black_25,
      },
      '& svg': {
        width: '28px',
        height: '28px',
      },
      '& path': {
        fill: colors.white,
      },
      '& img': {
        width: 'calc(100% + 2px)',
        height: 'calc(100% + 2px)',
        m: '-1px',
      },
      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        marginX: 0.5,
        width: 24,
        height: 24,
        '& svg': {
          width: '20px',
          height: '20px',
        },
        '& .MuiAvatar-circular': {
          fontSize: '12px',
        },
      },

      position: 'relative',
    },

    avatar: {
      position: 'absolute',
      width: '100%',
      height: '100%',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,

      border: `1px solid ${colors.white}`,
      borderRadius: '100%',
    },
  };
};
